import { TFunction } from '@util/types';
import _ from 'lodash';

export interface DrawerItem {
  header: string;
  type?: string;
  description?: string;
  sections?: InteriorFeatureItem[];
  list?: string[];
  taxes?: TaxData;
  arr?: ValueItem[];
}

interface InteriorFeatureItem {
  subheader: string;
  list?: string[];
  columns?: string[][];
  listColumned?: string[];
}

const mapDrawerData = (
  listingData,
  locale,
  enableNewCentrisFeed: boolean,
  t: TFunction,
): DrawerItem[] => {
  let drawerDataCollected: DrawerItem[] = [];
  let interiorFeaturesData: InteriorFeatureItem[] = [];
  let addenda: string[] = [];
  let inclusions: string[] = [];
  let exclusions: string[] = [];

  let dimensionsAndLayoutData: string[] = [];
  listingData.LivingArea && listingData.LivingAreaUnits
    ? dimensionsAndLayoutData.push(
        `${t('Living Area')}: ${listingData.LivingArea} ${listingData.LivingAreaUnits}`,
      )
    : null;

  dimensionsAndLayoutData.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Dimensions & Layout'),
        list: dimensionsAndLayoutData,
      })
    : null;

  let bedroomColsAll: string[][] = [];
  let bedroomsDataCol1: string[] = [];
  listingData.BedroomsTotal
    ? bedroomsDataCol1.push(`${t('Bedrooms')}: ${listingData.BedroomsTotal}`)
    : null;
  listingData.MasterBedroomDimensions
    ? bedroomsDataCol1.push(
        `${t('Primary Bedroom Dimensions')}: ${listingData.MasterBedroomDimensions}`,
      )
    : null;
  listingData.MasterBedroomLevel
    ? bedroomsDataCol1.push(`${t('Primary Bedroom Level')}: ${listingData.MasterBedroomLevel}`)
    : null;

  bedroomsDataCol1.length > 0 ? bedroomColsAll.push(bedroomsDataCol1) : null;

  let bedroomsDataCol2: string[] = [];
  listingData.BedroomDimensions1
    ? bedroomsDataCol2.push(`${t('Bedroom 1 Dimensions')}: ${listingData.BedroomDimensions1}`)
    : null;
  listingData.BedroomLevel1
    ? bedroomsDataCol2.push(`${t('Bedroom 1 Level')}: ${listingData.BedroomLevel1}`)
    : null;
  listingData.BedroomDimensions2
    ? bedroomsDataCol2.push(`${t('Bedroom 2 Dimensions')}: ${listingData.BedroomDimensions2}`)
    : null;
  listingData.BedroomLevel2
    ? bedroomsDataCol2.push(`${t('Bedroom 2 Level')}: ${listingData.BedroomLevel2}`)
    : null;
  listingData.BedroomDimensions3
    ? bedroomsDataCol2.push(`${t('Bedroom 3 Dimensions')}: ${listingData.BedroomDimensions3}`)
    : null;
  listingData.BedroomLevel3
    ? bedroomsDataCol2.push(`${t('Bedroom 3 Level')}: ${listingData.BedroomLevel3}`)
    : null;

  bedroomsDataCol2.length > 0 ? bedroomColsAll.push(bedroomsDataCol2) : null;

  let bedroomsDataCol3: string[] = [];
  listingData.BedroomDimensions4
    ? bedroomsDataCol3.push(`${t('Bedroom 4 Dimensions')}: ${listingData.BedroomDimensions4}`)
    : null;
  listingData.BedroomLevel4
    ? bedroomsDataCol3.push(`${t('Bedroom 4 Level')}: ${listingData.BedroomLevel4}`)
    : null;
  listingData.BedroomDimensions5
    ? bedroomsDataCol3.push(`${t('Bedroom 5 Dimensions')}: ${listingData.BedroomDimensions5}`)
    : null;
  listingData.BedroomLevel5
    ? bedroomsDataCol3.push(`${t('Bedroom 5 Level')}: ${listingData.BedroomLevel5}`)
    : null;
  listingData.BedroomDimensions3
    ? bedroomsDataCol3.push(`${t('Bedroom 6 Dimensions')}: ${listingData.BedroomDimensions6}`)
    : null;
  listingData.BedroomLevel6
    ? bedroomsDataCol3.push(`${t('Bedroom 6 Level')}: ${listingData.BedroomLevel6}`)
    : null;

  bedroomsDataCol3.length > 0 ? bedroomColsAll.push(bedroomsDataCol3) : null;

  bedroomColsAll.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Bedrooms'),
        columns: bedroomColsAll,
      })
    : null;

  let bathroomDataColAll: string[][] = [];
  let bathroomsDataCol1: string[] = [];
  listingData.BathroomsTotalInteger
    ? bathroomsDataCol1.push(
        `${t('Total Bathrooms')}: ${
          listingData.BathroomsTotalInteger || listingData.RawMlsBathroomsTotal
        }`,
      )
    : null;
  listingData.BathroomsFull
    ? bathroomsDataCol1.push(`${t('Full Bathrooms')}: ${listingData.BathroomsFull}`)
    : null;
  listingData.BathroomsHalf
    ? bathroomsDataCol1.push(`${t('Half Bathrooms')}: ${listingData.BathroomsHalf}`)
    : null;
  listingData.BathroomsThreeQuarter
    ? bathroomsDataCol1.push(
        `${t('Three Quarter Bathrooms')}: ${listingData.BathroomsThreeQuarter}`,
      )
    : null;
  bathroomsDataCol1.length > 0 ? bathroomDataColAll.push(bathroomsDataCol1) : null;

  let bathroomsDataCol2: string[] = [];
  listingData.MainLevelBathrooms
    ? bathroomsDataCol2.push(`${t('Main Level Bathrooms')}: ${listingData.MainLevelBathrooms}`)
    : null;
  bathroomsDataCol2.length > 0 ? bathroomDataColAll.push(bathroomsDataCol2) : null;

  bathroomDataColAll.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Bathrooms'),
        columns: bathroomDataColAll,
      })
    : null;

  let kitchenDiningData: string[] = [];
  listingData.KitchenDimensions
    ? kitchenDiningData.push(`${t('Kitchen Dimensions')}: ${listingData.KitchenDimensions}`)
    : null;
  listingData.KitchenLevel
    ? kitchenDiningData.push(`${t('Kitchen Level')}: ${listingData.KitchenLevel}`)
    : null;
  listingData.DiningRoomDimensions
    ? kitchenDiningData.push(`${t('Dining Room Dimensions')}: ${listingData.DiningRoomDimensions}`)
    : null;
  listingData.DiningRoomLevel
    ? kitchenDiningData.push(`${t('Dining Room Level')}: ${listingData.DiningRoomLevel}`)
    : null;

  kitchenDiningData.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Kitchen & Dining'),
        list: kitchenDiningData,
      })
    : null;

  let otherRoomsData: string[] = [];
  listingData.RoomsTotal
    ? otherRoomsData.push(`${t('Total Rooms')}: ${listingData.RoomsTotal}`)
    : null;
  listingData.MainLevelBedrooms
    ? otherRoomsData.push(`${t('Main Level Bedrooms')}: ${listingData.MainLevelBedrooms}`)
    : null;

  listingData.BasementYN
    ? otherRoomsData.push(`${t('Basement')}: ${getValueAsString(listingData.BasementYN, t)}`)
    : null;

  listingData.Basement
    ? otherRoomsData.push(
        `${t('Basement Description')}: ${getValueAsString(listingData.Basement, t)}`,
      )
    : null;

  listingData.FireplaceYN
    ? otherRoomsData.push(`${t('Fireplace')}: ${getValueAsString(listingData.FireplaceYN, t)}`)
    : null;

  listingData.FireplacesTotal
    ? otherRoomsData.push(`${t('Fireplace Total')}: ${listingData.FireplacesTotal}`)
    : null;

  listingData.DenStudyRoomLevel
    ? otherRoomsData.push(`${t('Den Room Level')}: ${listingData.DenStudyRoomLevel}`)
    : null;
  listingData.DenStudyRoomDimensions
    ? otherRoomsData.push(`${t('Den Room Dimensions')}: ${listingData.DenStudyRoomDimensions}`)
    : null;
  listingData.FamilyRoomLevel
    ? otherRoomsData.push(`${t('Family Room Level')}: ${listingData.FamilyRoomLevel}`)
    : null;
  listingData.FamilyRoomDimensions
    ? otherRoomsData.push(`${t('Family Room Dimensions')}: ${listingData.FamilyRoomDimensions}`)
    : null;
  listingData.LivingRoomLevel
    ? otherRoomsData.push(`${t('Living Room Level')}: ${listingData.LivingRoomLevel}`)
    : null;
  listingData.LivingRoomDimensions
    ? otherRoomsData.push(`${t('Living Room Dimensions')}: ${listingData.LivingRoomDimensions}`)
    : null;
  listingData.LaundryRoomLevel
    ? otherRoomsData.push(`${t('Laundry Room Level')}: ${listingData.LaundryRoomLevel}`)
    : null;
  listingData.LaundryRoomDimensions
    ? otherRoomsData.push(`${t('Laundry Room Dimensions')}: ${listingData.LaundryRoomDimensions}`)
    : null;

  otherRoomsData.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Other Rooms'),
        list: otherRoomsData,
      })
    : null;

  const frenchInclusions = enableNewCentrisFeed
    ? listingData.Custom5?.Inclusions
    : listingData.Custom7;
  const frenchExclusions = enableNewCentrisFeed
    ? listingData.Custom5?.Exclusions
    : listingData.Custom4;
  const frenchAddenda = enableNewCentrisFeed
    ? listingData.Custom5?.Addenda?.replace(/\\r\\n|\\n|\r\n|\n/g, '<br />')
    : listingData.Custom17;

  const englishInclusions = enableNewCentrisFeed ? listingData.Inclusions : listingData.Custom6;
  const englishExclusions = enableNewCentrisFeed ? listingData.Exclusions : listingData.Custom5;
  const englishAddenda = enableNewCentrisFeed
    ? listingData.Custom16?.replace(/\\r\\n|\\n|\r\n|\n/g, '<br />')
    : listingData.Custom16;

  englishAddenda && frenchAddenda && listingData.OriginatingSystemName === 'CENTRIS'
    ? addenda.push(locale?.toLowerCase() === 'fr-ca' ? frenchAddenda : englishAddenda)
    : null;

  englishInclusions && frenchInclusions && listingData.OriginatingSystemName === 'CENTRIS'
    ? inclusions.push(locale?.toLowerCase() === 'fr-ca' ? frenchInclusions : englishInclusions)
    : null;

  englishExclusions && frenchExclusions && listingData.OriginatingSystemName === 'CENTRIS'
    ? exclusions.push(locale?.toLowerCase() === 'fr-ca' ? frenchExclusions : englishExclusions)
    : null;

  const interiorFeatures = listingData.InteriorFeatures ?? [];
  if (listingData.Flooring) {
    interiorFeatures.push(`${t('Flooring')}: ${getValueAsString(listingData.Flooring, t)}`);
  }
  if (listingData.WindowFeatures) {
    interiorFeatures.push(
      `${t('Window Features')}: ${getValueAsString(listingData.WindowFeatures, t)}`,
    );
  }
  if (listingData.LaundryFeatures) {
    interiorFeatures.push(
      `${t('Laundry Features')}: ${getValueAsString(listingData.LaundryFeatures, t)}`,
    );
  }
  if (listingData.DoorFeatures) {
    interiorFeatures.push(
      `${t('Door Features')}: ${getValueAsString(listingData.DoorFeatures, t)}`,
    );
  }
  if (listingData.SecurityFeatures) {
    interiorFeatures.push(
      `${t('Security Features')}: ${getValueAsString(listingData.SecurityFeatures, t)}`,
    );
  }
  if (listingData.SpaYN) {
    interiorFeatures.push(`${t('Spa')}: ${getValueAsString(listingData.SpaYN, t)}`);
  }
  if (listingData.SpaFeatures) {
    interiorFeatures.push(`${t('Spa Features')}: ${getValueAsString(listingData.SpaFeatures, t)}`);
  }

  interiorFeatures.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Interior Features'),
        listColumned: interiorFeatures,
      })
    : null;

  listingData.Appliances
    ? interiorFeaturesData.push({
        subheader: t('Appliances'),
        listColumned: listingData.Appliances,
      })
    : null;

  let heatingCoolingData: string[] = [];
  listingData.Heating
    ? heatingCoolingData.push(`${t('Heating')}: ${getValueAsString(listingData.Heating, t)}`)
    : null;
  listingData.Cooling
    ? heatingCoolingData.push(`${t('Cooling')}: ${getValueAsString(listingData.Cooling, t)}`)
    : null;

  heatingCoolingData.length > 0
    ? interiorFeaturesData.push({
        subheader: t('Heating & Cooling'),
        list: heatingCoolingData,
      })
    : null;

  interiorFeaturesData.length > 0
    ? drawerDataCollected.push({
        header: t('Interior Features'),
        sections: [...interiorFeaturesData],
      })
    : null;

  inclusions.length > 0
    ? drawerDataCollected.push({
        header: locale?.toLowerCase() === 'fr-ca' ? t('Inclusion') : t('Inclusion'),
        list: [...inclusions],
      })
    : null;

  exclusions.length > 0
    ? drawerDataCollected.push({
        header: locale?.toLowerCase() === 'fr-ca' ? t('Exclusion') : t('Exclusion'),
        list: [...exclusions],
      })
    : null;

  addenda.length > 0
    ? drawerDataCollected.push({
        header: locale?.toLowerCase() === 'fr-ca' ? t('Addenda') : t('Addendum'),
        list: [...addenda],
      })
    : null;

  const utilitiesData = getUtilitiesData(listingData, t);
  if (utilitiesData.length > 0) {
    drawerDataCollected.push({
      type: 'Utilities',
      header: t('Utilities'),
      arr: utilitiesData,
    });
  }

  if (listingData?.PropertyRooms && listingData?.PropertyRooms.length > 0) {
    drawerDataCollected.push({
      header: t('Dimensions & Layout'),
      sections: getDimensionsData(listingData?.PropertyRooms, t),
    });
  }

  const taxes = getTaxesData(listingData, enableNewCentrisFeed, t);
  if (taxes.annual.data?.length > 0 || taxes.municipal.data?.length > 0) {
    drawerDataCollected.push({
      type: 'Taxes',
      header: t('Taxes (Annual)'),
      taxes,
    });
  }

  const exteriorFeaturesData = getExteriorFeaturesData(listingData, t);
  if (exteriorFeaturesData.length > 0) {
    drawerDataCollected.push({
      type: 'ExteriorFeatures',
      header: t('Exterior Features'),
      arr: exteriorFeaturesData,
    });
  }

  const constructionData = getConstructionData(listingData, t);
  if (constructionData.length > 0) {
    drawerDataCollected.push({
      type: 'Construction',
      header: t('Construction'),
      arr: constructionData,
    });
  }

  const parkingData = getParkingData(listingData, t);
  if (parkingData.length > 0) {
    drawerDataCollected.push({
      type: 'Parking',
      header: t('Parking'),
      arr: parkingData,
    });
  }
  const additionalTermsData = getAdditionalTermsData(listingData, t);
  if (additionalTermsData.length > 0) {
    drawerDataCollected.push({
      type: 'AdditionalTerms',
      header: t('Additional Terms'),
      arr: additionalTermsData,
    });
  }

  return drawerDataCollected;
};

interface ValueItem {
  header: string;
  content: string;
}

const getUtilitiesData = (listingData, t: TFunction): ValueItem[] => {
  let data: ValueItem[] = [];
  const { Utilities, WaterSource, Sewer } = listingData;
  data.push({
    header: 'Utilities',
    content: getValueAsString(Utilities, t),
  });
  data.push({
    header: 'Water Source',
    content: getValueAsString(WaterSource, t),
  });
  data.push({
    header: 'Sewer',
    content: getValueAsString(Sewer, t),
  });

  return data.filter((obj) => obj.content !== '-');
};

const getAdditionalTermsData = (listingData, t: TFunction): ValueItem[] => {
  const data: ValueItem[] = [];
  if (listingData?.buyerBrokerOfferToCompensate) {
    data.push({
      header: 'Compensation for Buyer’s Representatives',
      content: getValueAsString(listingData?.buyerBrokerOfferToCompensate, t),
    });
  }
  if (listingData?.sellerConcessions) {
    data.push({
      header: 'Seller Concessions',
      content: getValueAsString(listingData?.sellerConcessions, t),
    });
  }
  if (listingData?.buyerBrokerOfferToCompensate || listingData?.sellerConcessions) {
    data.push({
      header: 'Notice',
      content:
        t('buyerSellerCommissionDisclaimer') +
        ' \n\n ' +
        getValueAsString(listingData?.disclaimer, t),
    });
  }
  return data.filter((obj) => obj.content !== '-');
};

const getParkingData = (listingData, t: TFunction): ValueItem[] => {
  const data: ValueItem[] = [];
  const { ParkingTotal, GarageYN, GarageSpaces, ParkingFeatures } = listingData;
  data.push({
    header: 'Parking Total',
    content: getValueAsString(ParkingTotal, t),
  });
  data.push({
    header: 'Garage',
    content: getValueAsString(GarageYN, t),
  });
  data.push({
    header: 'Garage Spaces',
    content: getValueAsString(GarageSpaces, t),
  });
  data.push({
    header: 'Parking Features',
    content: getValueAsString(ParkingFeatures, t),
  });

  return data.filter((obj) => obj.content !== '-');
};

const getExteriorFeaturesData = (listingData, t: TFunction): ValueItem[] => {
  const data: ValueItem[] = [];
  const {
    LotFeatures,
    PatioAndPorchFeatures,
    Fencing,
    PoolFeatures,
    WaterfrontFeatures,
    WaterBodyName,
  } = listingData;
  data.push({
    header: 'Lot Features',
    content: getValueAsString(LotFeatures, t),
  });
  data.push({
    header: 'Patio And Porch Features',
    content: getValueAsString(PatioAndPorchFeatures, t),
  });
  data.push({
    header: 'Fencing',
    content: getValueAsString(Fencing, t),
  });
  data.push({
    header: 'Pool Features',
    content: getValueAsString(PoolFeatures, t),
  });
  data.push({
    header: 'Waterfront Features',
    content: getValueAsString(WaterfrontFeatures, t),
  });
  data.push({
    header: 'WaterBody Name',
    content: getValueAsString(WaterBodyName, t),
  });

  return data.filter((obj) => obj.content !== '-');
};

const getConstructionData = (listingData, t: TFunction): ValueItem[] => {
  const data: ValueItem[] = [];
  const {
    PropertyType,
    PropertySubType,
    ArchitecturalStyle,
    ConstructionMaterials,
    YearBuilt,
    FoundationDetails,
    Roof,
    Flooring,
    NewConstructionYN,
    PropertyCondition,
    AboveGradeFinishedArea,
    BelowGradeFinishedArea,
    BuildingAreaTotal,
  } = listingData;
  data.push({
    header: 'Property Type',
    content: getValueAsString(PropertyType, t),
  });
  data.push({
    header: 'Construction Materials',
    content: getValueAsString(ConstructionMaterials, t) ?? '-',
  });
  data.push({
    header: 'Flooring',
    content: getValueAsString(Flooring, t) ?? '-',
  });
  data.push({
    header: 'Year Built',
    content: getValueAsString(YearBuilt, t) ?? '-',
  });
  data.push({
    header: 'Property Subtype',
    content: getValueAsString(PropertySubType, t) ?? '-',
  });
  data.push({
    header: 'Foundation Details',
    content: getValueAsString(FoundationDetails, t) ?? '-',
  });
  data.push({
    header: 'New Construction',
    content: getValueAsString(NewConstructionYN, t) ?? '-',
  });
  data.push({
    header: 'Architectural Style',
    content: getValueAsString(ArchitecturalStyle, t) ?? '-',
  });
  data.push({
    header: 'Roof',
    content: getValueAsString(Roof, t) ?? '-',
  });
  data.push({
    header: 'Property Condition',
    content: getValueAsString(PropertyCondition, t) ?? '-',
  });
  data.push({
    header: 'Above Grade Finished Area',
    content: getValueAsString(AboveGradeFinishedArea, t) ?? '-',
  });
  data.push({
    header: 'Below Grade Finished Area',
    content: getValueAsString(BelowGradeFinishedArea, t) ?? '-',
  });
  data.push({
    header: 'Building Area Total',
    content: getValueAsString(BuildingAreaTotal, t) ?? '-',
  });

  return data.filter((obj) => obj.content !== '-');
};

const getValueAsString = (
  val: boolean | string | number | null | string[],
  t: TFunction,
): string => {
  if (val == null || val === '' || val === 0) return '-';
  if (Array.isArray(val)) {
    return val.join(', ');
  }
  if (val === true || val === false) {
    return val === true ? t('Yes') : t('No');
  }
  return val.toString();
};

interface TaxData {
  municipal: TaxDataSection;
  annual: TaxDataSection;
}

interface TaxDataSection {
  name: string;
  data: {
    name: string;
    year: number;
    value: number;
    type: string;
  }[];
}

const getTaxesData = (listingData, enableNewCentrisFeed: boolean, t: TFunction) => {
  const { Custom1, Custom18 } = listingData;
  const taxYearData: TaxData = {
    municipal: {
      name: t('Municipal Assessment'),
      data: [],
    },
    annual: {
      name: t('Taxes (Annual)'),
      data: [],
    },
  };

  if (enableNewCentrisFeed) {
    // Filter for entries where ExpenseYear is 2025
    const filteredExpenses =
      Custom1?.filter((expense) => expense.ExpenseYear === listingData.TaxYear?.toString()) ?? [];

    // Process the filtered expenses and calculate the total
    let totalValue = 0;

    if (filteredExpenses?.length) {
      filteredExpenses?.forEach((expense) => {
        const { ExpenseAmount, ExpenseSubType, ExpenseType } = expense;

        const value = parseFloat(ExpenseAmount || '0');
        totalValue += value;

        taxYearData.annual.data.push({
          name: t(ExpenseSubType || ExpenseType), // Use SubType if available, otherwise Type
          year: listingData.TaxYear,
          value,
          type: ExpenseSubType || ExpenseType,
        });
      });

      // Add the total entry
      if (totalValue > 0) {
        taxYearData.annual.data.push({
          name: t('Total'),
          year: listingData.TaxYear,
          value: totalValue,
          type: 'Total',
        });
      }
    }
  } else {
    for (let year in Custom18) {
      if (year != null && isNumeric(year)) {
        const yearTaxData = Custom18[year];
        for (let taxCode in yearTaxData) {
          if (taxCode !== 'TOTAL') {
            const { AMOUNT, TAX_CODE, YEAR } = yearTaxData[taxCode];
            taxYearData['annual'].data.push({
              name: taxCodeMap[TAX_CODE] ? t(taxCodeMap[TAX_CODE]) : TAX_CODE,
              year: parseInt(YEAR),
              value: AMOUNT,
              type: taxCodeMap[TAX_CODE] || TAX_CODE,
            });
          } else {
            taxYearData['annual'].data.push({
              name: t('Total'),
              year: parseInt(year),
              value: parseInt(yearTaxData[taxCode]),
              type: 'Total',
            });
          }
        }
      }
    }
  }

  // INFO: Remove RawMlsProperty as it was causing issue
  if (listingData?.RawMlsProperty) {
    const RawMlsProperty = listingData?.RawMlsProperty;
    for (let mlsProperty of RawMlsProperty) {
      const { RawMlsFields } = mlsProperty;

      if (RawMlsFields) {
        const { EVALUATION_MUNICIPALE_BATIMENT, EVALUATION_MUNICIPALE_TERRAIN, ANNEE_EVALUATION } =
          RawMlsFields;
        if (ANNEE_EVALUATION != null && isNumeric(ANNEE_EVALUATION)) {
          const year = parseInt(ANNEE_EVALUATION || 0);
          const totalAmount =
            parseInt(EVALUATION_MUNICIPALE_BATIMENT || 0) +
            parseInt(EVALUATION_MUNICIPALE_TERRAIN || 0);

          const yearData = [
            {
              name: taxCodeMap['ANNEE_EVALUATION'],
              year,
              value: ANNEE_EVALUATION,
              type: taxCodeMap['ANNEE_EVALUATION'],
            },
            {
              name: taxCodeMap['EVALUATION_MUNICIPALE_BATIMENT'],
              year,
              value: parseInt(EVALUATION_MUNICIPALE_BATIMENT),
              type: taxCodeMap['EVALUATION_MUNICIPALE_BATIMENT'],
            },
            {
              name: taxCodeMap['EVALUATION_MUNICIPALE_TERRAIN'],
              year,
              value: parseInt(EVALUATION_MUNICIPALE_TERRAIN),
              type: taxCodeMap['EVALUATION_MUNICIPALE_TERRAIN'],
            },
            {
              name: t('Total'),
              value: totalAmount,
              year,
              type: 'Total',
            },
          ];
          taxYearData['municipal'].data = taxYearData['municipal'].data.concat(yearData);
        }
      }
    }
  }

  taxYearData.annual.data?.sort((a, b) => b.year - a.year);
  taxYearData.municipal.data?.sort((a, b) => b.year - a.year);

  const latestYear = taxYearData.annual.data?.[0]?.year;
  taxYearData.annual.data = taxYearData.annual.data?.filter((taxObj) => taxObj.year === latestYear);

  return taxYearData;
};

const taxCodeMap = {
  TAXMUN: 'Municipal',
  TAXSCO: 'School',
  EVALUATION_MUNICIPALE_BATIMENT: 'Building',
  EVALUATION_MUNICIPALE_TERRAIN: 'Lot',
  ANNEE_EVALUATION: 'Year',
};

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

interface DimensionsData {
  subheader: string;
  dimensions: {
    [key: string]: string;
  }[];
}

const getDimensionsData = (dimensionsData, t: TFunction): DimensionsData[] => {
  let sections: DimensionsData[] = [];
  const roomTypeJSON = _.groupBy(
    dimensionsData.filter((obj) => obj['RawMlsRoomLevel']),
    'RawMlsRoomLevel',
  );

  const noRoomLevelData = dimensionsData.filter((obj) => !obj['RawMlsRoomLevel']);

  for (let roomType in roomTypeJSON) {
    sections.push({
      subheader: roomType,
      dimensions: roomTypeJSON[roomType]!.filter(
        (obj) => obj.RawMlsRoomType && obj.RoomDimensions,
      ).map((obj) => {
        return {
          [t(obj.RawMlsRoomType)]: obj.RoomDimensions,
        };
      }),
    });
  }

  if (noRoomLevelData?.length > 0) {
    sections.push({
      subheader: t('Other'),
      dimensions: noRoomLevelData
        .filter((obj) => obj.RawMlsRoomType && obj.RoomDimensions)
        .map((obj) => {
          return {
            [t(obj.RawMlsRoomType)]: obj.RoomDimensions,
          };
        }),
    });
  }
  return sections;
};

export default mapDrawerData;
